import React from 'react';
import { NavLink } from 'react-router-dom';
const Uganda1_kindergarten_subjects = () => {
  return (
    <div className='fixed top-16 right-0 left-0 h-7 justify-items-stretch w-full content-center gap-4 overflow-x-scroll whitespace-nowrap scroll-smooth flex scrollbar-hide bg-cyan-400 items-center z-50 justify-evenly'>
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_kindergarten/uganda1_kindergarten_lang" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Language and Literacy</NavLink>     
      
      <NavLink to="/tutoring/learner/uganda1/uganda1_kindergarten/uganda1_kindergarten_math" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Mathematical Concepts</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_kindergarten/uganda1_kindergarten_envir" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Environmental Interaction: Science/Social Studies</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_kindergarten/uganda1_kindergarten_pers" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Personal and Social Development </NavLink> 
        <NavLink to="/tutoring/learner/uganda1/uganda1_kindergarten/uganda1_kindergarten_phy" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Physical Development: Health/Motor skills</NavLink>
        <NavLink to="/tutoring/learner/uganda1/uganda1_kindergarten/uganda1_kindergarten_crea" className={({ isActive }) =>
          isActive
            ? 'bg-blue-600 text-white px-3 py-2 rounded-md' // Active styles
            : 'text-black hover:bg-gray-700 hover:text-white px-3 py-2 rounded-md' // Inactive styles
        }
      >Creative and Expressive Arts</NavLink>
        
    </div>
  );
}

export default Uganda1_kindergarten_subjects;
